/* tslint:disable */
/* eslint-disable */
export enum CashFundTransactionStatusEnum {
  Waiting = 1,
  Expired = 2,
  Success = 3,
  Failed = 4,
  Canceled = 5,
  Authorized = 6,
}
